export default {
  hero: {
    label: 'Doporučené novinky',
    eyebrow: 'Doporučujeme',
    browse: 'Procházet katalog',
    goToSlide: 'Přejít na snímek {n}',
  },
  comingSoon: 'Již brzy',
  games: '{count} hra | {count} hry | {count} her',
  stats: {
    inStock: 'Klíčů skladem',
    preorders: 'Předobjednávky',
  },
  recent: { title: 'Naposledy zobrazené' },
  newest: { title: 'Novinky v obchodě' },
  under5: { title: 'Do 5 €' },
  preorders: { title: 'Předobjednávky' },
  how: {
    wallet: 'Peněženka KeyzoStore',
    invoice: 'PDF faktura ke každému dobití',
    keyNote: 'V objednávkách i v e-mailu',
    pick: { title: 'Vyberte hru', body: 'Procházejte klíče, které jsou právě skladem.' },
    pay: { title: 'Zaplaťte, jak chcete' },
    receive: { title: 'Získejte klíč' },
  },
  genres: {
    title: 'Procházet podle žánru',
  },
  cta: {
    title: 'Vytvořte si účet zdarma',
    body: 'Ukládejte si oblíbené hry, sledujte objednávky a mějte klíče na jednom místě.',
  },
};
